import { Component, OnInit } from "@angular/core";
import { AlertController, ModalController, NavParams } from "@ionic/angular";
import { Directory, Filesystem } from "@capacitor/filesystem";
import { DomSanitizer } from "@angular/platform-browser";
import { MissionService } from "src/app/services/mission.service";
import { NetworkService } from "src/app/services/network.service";
import { ApiPhotoService } from "src/app/services/api/api-photo.service";

@Component({
  selector: "app-modal-pictures",
  templateUrl: "./modal-pictures.component.html",
  styleUrls: ["./modal-pictures.component.scss"],
  standalone: false,
})
export class ModalPicturesComponent implements OnInit {
  photos;
  enCours;
  index = 0;
  lectureSeule = false;
  mission;

  constructor(
    private navParams: NavParams,
    private modalCtrl: ModalController,
    public sanitizer: DomSanitizer,
    private alertCtrl: AlertController,
    private missionService: MissionService,
    private networkService: NetworkService,
    private apiPhotoService: ApiPhotoService
  ) {}

  ngOnInit() {
    this.photos = this.navParams.get("photos");
    this.index = this.navParams.get("index");
    this.lectureSeule = this.navParams.get("lectureSeule");
    this.mission = this.navParams.get("mission");
    this.enCours = this.photos[this.index];
  }

  dismiss() {
    this.modalCtrl.dismiss({ photos: this.photos });
  }

  prevSlide() {
    this.index--;
    this.enCours = this.photos[this.index];
  }

  nextSlide() {
    this.index++;
    this.enCours = this.photos[this.index];
  }

  async delete(photo) {
    const alert = await this.alertCtrl.create({
      message: "Voulez-vous vraiment supprimer cette photo ?",
      buttons: [
        {
          text: "Annuler",
          role: "cancel",
        },
        {
          text: "OK",
          role: "confirm",
        },
      ],
    });
    await alert.present();
    const { role } = await alert.onDidDismiss();

    if (role === "confirm") {
      this.photos.splice(this.photos.indexOf(photo), 1);
      console.log(photo);
      // Delete photo from server
      if (photo.fr_photoid) {
        if (this.networkService.isOnline) {
          // Online: delete immediately on server
          try {
            await this.apiPhotoService.deletePhoto(photo.fr_photoid);
          } catch (error) {
            console.error("Error deleting photo from server:", error);
            // Fallback: store for later deletion if immediate deletion fails
            this.missionService.addPhotoToDelete(
              photo.fr_photoid,
              "filrouge_delete"
            );
          }
        } else {
          // Offline: store for later deletion
          this.missionService.addPhotoToDelete(
            photo.fr_photoid,
            "filrouge_delete"
          );
        }
      }

      // Delete local file
      Filesystem.deleteFile({
        path: photo.filepath,
        directory: Directory.Data,
      }).finally(async () => {
        // Save mission to storage after deleting photo
        if (this.mission) {
          await this.missionService.saveInStorage(this.mission);
        }
        this.exit();
      });
    }
  }

  exit() {
    if (this.photos.length > 0) {
      this.enCours = this.photos[0];
      this.index = 0;
    } else {
      this.dismiss();
    }
  }
}
